import { SideBarItemConfig } from "../app/models/menu/sideBar";
import {
  PatientRequest,
  SettingIcon,
  createRequest,
  requestHistory,
  swatch,
} from "../assets/components/svgs";

import { RouteConstants } from "../constants/RouteConstants";

// These are for mapping view/menu keys to paths in the router
const keyPaths = Object.freeze([
  {
    key: "Patient Requests",
    icon: PatientRequest,
  },
  {
    key: "Create Request",
    label: "T_CREATE_REQUEST",
    path: RouteConstants.ROUTE_GDPR_CREATE,
    icon: createRequest,
  },
  {
    key: "Request History",
    label: "T_REQUEST_HISTORY",
    path: RouteConstants.ROUTE_GDPR_LIST,
    icon: requestHistory,
  },
  {
    key: "Settings",
    icon: SettingIcon,
  },
  {
    key: "Customization",
    label: "Customization",
    path: RouteConstants.ROUTE_CUSTOMIZATION,
    icon: swatch,
  },
]);

export default keyPaths as SideBarItemConfig[];
